import React from "react";
import { Row, Col, FormGroup, Label, Button } from "reactstrap";
import { NumericFormat } from "react-number-format";
import Select from "react-select";
import FeatherIcon from "feather-icons-react";

// AIDEV-NOTE: Sub-operation build form with Select for suppliers and correct fields structure
const SubOperationBuildForm = ({
  buildFormData,
  handleBuildFormChange,
  handleBuildSubOperation,
  listaFornecedores,
  moeda,
  direcao,
  setViewMode,
  setModalFornecedor,
}) => {
  const isFormValid =
    buildFormData.fornecedor_id &&
    buildFormData.quantidade &&
    buildFormData.total_brl;

  const fornecedorSelecionado = listaFornecedores.find(
    (f) => f.value === buildFormData.fornecedor_id
  );

  // Direção contrária à operação principal
  const direcaoSubOperacao = direcao === "compra" ? "venda" : "compra";

  // Calcular cotação estimada (apenas para visualização)
  const cotacaoEstimada =
    buildFormData.quantidade && buildFormData.total_brl
      ? (
          parseFloat(buildFormData.total_brl) /
          parseFloat(buildFormData.quantidade)
        ).toFixed(2)
      : "0,00";

  return (
    <div>
      <h6 className="mb-3">Construir Nova Sub-operação</h6>

      {/* Informações da sub-operação */}
      <div className="mb-3 p-2 bg-light rounded">
        <div className="row">
          <div className="col-6">
            <small className="text-muted">Direção:</small>
            <div
              className={`fw-medium ${
                direcaoSubOperacao === "compra" ? "text-success" : "text-danger"
              }`}
            >
              <FeatherIcon
                icon={
                  direcaoSubOperacao === "compra"
                    ? "trending-up"
                    : "trending-down"
                }
                size={14}
                className="me-1"
              />
              {direcaoSubOperacao.toUpperCase()}
            </div>
          </div>
          <div className="col-6">
            <small className="text-muted">Moeda:</small>
            <div className="fw-medium text-primary">
              <FeatherIcon icon="dollar-sign" size={14} className="me-1" />
              {moeda?.data?.moeda || "N/A"}
            </div>
          </div>
        </div>
      </div>

      <FormGroup>
        <Label>Fornecedor *</Label>
        <div className="d-flex gap-2">
          <div className="flex-grow-1">
            <Select
              value={fornecedorSelecionado || null}
              onChange={(option) =>
                handleBuildFormChange("fornecedor_id", option?.value || null)
              }
              options={listaFornecedores}
              placeholder="Selecione um fornecedor..."
              isSearchable
              isClearable
              noOptionsMessage={() => "Nenhum fornecedor encontrado"}
            />
          </div>
          <Button
            color="outline-primary"
            size="sm"
            onClick={() => setModalFornecedor(true)}
            title="Cadastrar novo fornecedor"
          >
            <FeatherIcon icon="plus" size={14} />
          </Button>
        </div>
        <small className="text-muted">
          Selecione o fornecedor para esta sub-operação
        </small>
      </FormGroup>

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Quantidade *</Label>
            <NumericFormat
              className="form-control"
              value={buildFormData.quantidade}
              onValueChange={({ value }) =>
                handleBuildFormChange("quantidade", value)
              }
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={moeda?.data?.moeda === "BRL" ? 2 : 6}
              fixedDecimalScale={false}
              allowNegative={false}
              placeholder={moeda?.data?.moeda === "BRL" ? "0,00" : "0,000000"}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Total BRL *</Label>
            <NumericFormat
              className="form-control"
              value={buildFormData.total_brl}
              onValueChange={({ value }) =>
                handleBuildFormChange("total_brl", value)
              }
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale={false}
              allowNegative={false}
              placeholder="0,00"
              prefix="R$ "
            />
          </FormGroup>
        </Col>
      </Row>

      {/* Cotação estimada (apenas informativa) */}
      {buildFormData.quantidade && buildFormData.total_brl && (
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>
                Cotação Estimada
                <small className="text-muted"> (informativa)</small>
              </Label>
              <NumericFormat
                className="form-control bg-light"
                value={cotacaoEstimada}
                displayType="text"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale={true}
                prefix="R$ "
              />
            </FormGroup>
          </Col>
        </Row>
      )}

      <div className="d-flex gap-2 justify-content-end">
        <Button color="secondary" size="sm" onClick={() => setViewMode("list")}>
          Cancelar
        </Button>
        <Button
          color="primary"
          size="sm"
          onClick={handleBuildSubOperation}
          disabled={!isFormValid}
        >
          <FeatherIcon icon="plus" className="me-1" size={14} />
          Adicionar
        </Button>
      </div>
    </div>
  );
};

export default SubOperationBuildForm;
